/**
 * Reviews data list.
 * Add, edit, or remove reviews here — the Reviews component
 * will automatically pick up changes.
 *
 * Each review object:
 *  @property {string} name    — Reviewer's name
 *  @property {string} role    — Reviewer's role (e.g. "Parent", "Student")
 *  @property {string} comment — The review text
 */
const REVIEWS = [
  {
    name: "Ravi Sharma",
    role: "Parent",
    comment:
      "The program is engaging, well structured, and truly impactful. After enrolling our son into Yuva Quest, we noticed significant improvement in his confidence, stronger problem solving skills, communication skills, and willingness to take initiative.",
  },
  {
    name: "Amit Gupta",
    role: "Parent",
    comment:
      "Yuva Quest makes learning so much fun. My favourite part is the quiz section where kids can earn trophies and get encouraged to learn more. And it’s so amazing that the kids learn about Indian festivals through the interactive maps.",
  },
  {
    name: "Pankaj Mehta",
    role: "Parent",
    comment:
      "As a parent, I was looking for a platform that teaches Indian culture in a modern way. Yuva Quest does exactly that. My kids are hooked and learning at the same time!",
  },
  {
    name: "Priya Patel",
    role: "Parent",
    comment:
      "What impressed us most was how excited our daughter was to attend every session. Yuva Quest has been a wonderful experience for her. She spends her screen time on Yuva Quest now instead of random videos. The content is educational, safe, and beautifully designed. Highly recommended!",
  },
  // {
  //   name: "Sunita Verma",
  //   role: "Parent",
  //   comment:
  //     "I used to find history boring, but Yuva Quest changed that completely. The Festival section is super cool, it feels like a real adventure!",
  // },
  {
    name: "Karan Singh",
    role: "Parent",
    comment:
      "My kid used to find history boring, but Yuva Quest changed that completely. Each section is super cool, and feels like a real adventure to the kids!",
  },
  {
    name: "Kuldeep Singh",
    role: "Parent",
    comment:
      "Finally a platform that connects my children to their roots. The stories are age appropriate and the challenges keep them engaged for hours. Wonderful initiative!",
  },
];

export default REVIEWS;
